/** App-wide context: the API client and the auth state it draws its token from. */

import { createContext, useContext } from 'react'

import type { TikTokHubApi } from '../api/client'
import type { Auth } from '../auth/session'

export interface AppContextValue {
  api: TikTokHubApi
  auth: Auth
  /** bumped when the tester signs in/out so consumers re-fetch */
  authEpoch: number
  signOut: () => void
}

const AppContext = createContext<AppContextValue | null>(null)

export const AppProvider = AppContext.Provider

export function useApp(): AppContextValue {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useApp outside AppProvider')
  return ctx
}

export function useApi(): TikTokHubApi {
  return useApp().api
}
